import { emptyList1g2z5xcrvp2zy as emptyList } from './CollectionsKt.mjs';
import { Paire9pteg33gng7 as Pair } from '../Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toList(_this__u8e3s4) {
  if (_this__u8e3s4.q2() === 0)
    return emptyList();
  var iterator = _this__u8e3s4.l3().p1();
  if (!iterator.q1())
    return emptyList();
  var first = iterator.r1();
  if (!iterator.q1()) {
    // Inline function 'kotlin.collections.toPair' call
    var tmp$ret$0 = new (Pair())(first.m3(), first.n3());
    return listOf(tmp$ret$0);
  }
  var result = ArrayList().h2(_this__u8e3s4.q2());
  // Inline function 'kotlin.collections.toPair' call
  var tmp$ret$1 = new (Pair())(first.m3(), first.n3());
  result.i2(tmp$ret$1);
  do {
    // Inline function 'kotlin.collections.toPair' call
    var this_0 = iterator.r1();
    var tmp$ret$2 = new (Pair())(this_0.m3(), this_0.n3());
    result.i2(tmp$ret$2);
  }
   while (iterator.q1());
  return result;
}
//region block: exports
export {
  toList as toList2zksu85ukrmi,
};
//endregion

//# sourceMappingURL=_Maps.mjs.map
